import { ReactNode } from "react"
import styles from "./styles.module.scss"

export const QuoteCard = ({ children, title }: { children: ReactNode; title: string }) => {
  return (
    <>
      <div className={styles.cardHeading}>
        <p className={styles.cardTitle}>{title}</p>
      </div>
      <div className={styles.cardContent}>{children}</div>
    </>
  )
}
